import { useQueryClient } from '@tanstack/react-query';
import { useOptimisticMutation } from '../../../hooks/use-optimistic-mutation';
import type { APIKey } from '../types';
import { useAPISettingsApi } from './use-api-settings-api';
import { QK_API_SETTINGS_LIST_KEYS } from './use-api-settings-keys';

export function useAPISettingsDelete() {
  const { APISettingsApi } = useAPISettingsApi();
  const queryClient = useQueryClient();

  return useOptimisticMutation<APIKey[], string>({
    queryClient,
    queryKey: QK_API_SETTINGS_LIST_KEYS(),
    mutationFn: async (clientId: string) => await APISettingsApi.delete(clientId),
    optimisticUpdate: (prev, clientId) => prev?.filter((key) => key.client_id !== clientId) ?? [],
  });
}
